import React, { useState, useEffect } from 'react';
import moment from 'moment';
import 'moment-timezone';

const CountdownTimer = ({ matchDate, matchTimeGMT }) => {
  const calculateTimeLeft = () => {
    const targetGMT = moment.utc(`${matchDate} ${matchTimeGMT}`);
    const targetIST = targetGMT.clone().add(5, 'hours').add(30, 'minutes');
    const nowIST = moment().tz('Asia/Kolkata');
    const duration = moment.duration(targetIST.diff(nowIST));

    return {
      total: duration.asSeconds(),
      days: Math.floor(duration.asDays()),
      hours: duration.hours(),
      minutes: duration.minutes(),
      seconds: duration.seconds()
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();
      if (newTimeLeft.total <= 0) {
        setIsExpired(true);
        clearInterval(timer);
      } else {
        setTimeLeft(newTimeLeft);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [matchDate, matchTimeGMT]);

  if (isExpired) return null;

  return (
    <div className="matchCountdown mfix_1789">
      <span>Starts in </span>
      <div className="count">{timeLeft.days} DAYS TO GO</div>
      <div className="fixtureTimerCountdown">
        <span className="iconFont days fixtureTimer">
          <span className="timervalue">{String(timeLeft.days).padStart(2, '0')}</span>
          <span className="timerLabel">DAYS</span>
        </span>
        <span className="iconFont hrs fixtureTimer">
          <span className="timervalue">{String(timeLeft.hours).padStart(2, '0')}</span>
          <span className="timerLabel">HRS</span>
        </span>
        <span className="iconFont mins fixtureTimer">
          <span className="timervalue">{String(timeLeft.minutes).padStart(2, '0')}</span>
          <span className="timerLabel">MINS</span>
        </span>
        <span className="iconFont secs fixtureTimer">
          <span className="timervalue">{String(timeLeft.seconds).padStart(2, '0')}</span>
          <span className="timerLabel">SECS</span>
        </span>
      </div>
    </div>
  );
};

export default CountdownTimer;